// extracted by mini-css-extract-plugin
export default {"button":"FetchButton_button__w6+7l","loader":"FetchButton_loader__vx1zm","spin":"FetchButton_spin__yB565"};